<template>
  <baidu-map id="mapContainer" ref="mapContainer" class="map" center="上海" :scroll-wheel-zoom="map.scrollWheelZoom"
    :dragging="map.dragging" :double-click-zoom="map.dbClickZoom" :mapStyle="map.mapStyle" @ready="ready">
    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
    <bm-control :offset="{width:10,height:10}">
      <select-device-status @change="changeDeviceStatus"></select-device-status>
    </bm-control>
    <bml-heatmap :data="heatmap.data" :max="heatmap.max" :radius="heatmap.radius" :gradient="heatmap.gradient">
    </bml-heatmap>
  </baidu-map>
</template>
<script>
  import SelectDeviceStatus from "@/components/Selectors/DeviceStatus";
  import {
    BmlHeatmap
  } from 'vue-baidu-map'
  export default {
    components: {
      SelectDeviceStatus,
      BmlHeatmap
    },
    watch: {},
    data() {
      return {
        // 地图容器参数
        map: {
          mapInterface: null, //BMap类
          mapInstance: null, //map实例
          scrollWheelZoom: true,
          dragging: true,
          dbClickZoom: false,
          mapStyle: {
            styleJson: [{
                featureType: "highway",
                elementType: "all",
                stylers: {
                  visibility: "off"
                }
              },
              {
                featureType: "subway",
                elementType: "all",
                stylers: {
                  visibility: "off"
                }
              }
            ]
          }
        },
        devices: [], //所有的设备
        heatmap: {
          data: [],
          max: 100,
          radius: 30,
          gradient: {
            0: 'rgb(102, 255, 0)',
            .995: 'rgb(255, 170, 0)',
            1: 'rgb(255, 0, 0)'
          }
        }
      };
    },
    created() {
      this.searchDevices();
    },
    mounted() {},
    methods: {
      ready(params) {
        this.map.mapInterface = params.BMap;
        this.map.mapInstance = params.map;
      },
      changeDeviceStatus(value) {
        this.heatmap.data = [];
        if (value.length == 0) {
          this.devices.map(device => this.heatmap.data.push({
            lng: device.lon,
            lat: device.lat,
            count: 100
          }));
        } else {
          for (let i = 0; i < this.devices.length; i++) {
            const device = this.devices[i];
            if (value.in_array(device.status * 1)) {
              this.heatmap.data.push({
                lng: device.lon,
                lat: device.lat,
                count: 100
              });
            }
          }
        }
      },
      searchDevices() {
        this.$getJSON("/terminal/s_devicelst_all", {}).then(res => {
          this.devices = res.data;
          this.heatmap.data = [];
          this.devices.map(device => this.heatmap.data.push({
            lng: device.lon,
            lat: device.lat,
            count: 100
          }));
        });
      }
    }
  };

</script>
<style scoped>
  .map {
    width: 100%;
    height: 800px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/DeviceHeatmap.vue